import { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { useThemeMode } from '_metronic/partials'
import { getCSS } from '_metronic/assets/ts/_utils'

interface StakeChartProps {
  color: string
  value: number
  secondaryColor?: string
}

const StakeChart: React.FC<StakeChartProps> = ({ color, secondaryColor, value }) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()

  useEffect(() => {
    const chart = refreshChart()

    return () => {
      if (chart) {
        chart.destroy()
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, mode, value])

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const height = parseInt(getCSS(chartRef.current, 'height'))

    const chart = new ApexCharts(
      chartRef.current,
      getChartOptions(height, color, value, secondaryColor)
    )
    if (chart) {
      chart.render()
    }

    return chart
  }

  return (
    <>
      {/* begin::Chart */}
      <div
        ref={chartRef}
        id='kt_charts_stake_chart'
        className='mixed-widget-4-chart'
        style={{ height: '155px' }}></div>
      {/* end::Chart */}

      <style>
        {`
            #kt_charts_stake_chart .apexcharts-legend {
                display: flex;
                flex-direction: row;
            }
        `}
      </style>
    </>
  )
}

function getChartOptions (
  height: number,
  color: string,
  value: number,
  secondaryColor?: string
): ApexOptions {
  return {
    series: [value],
    chart: {
      type: 'radialBar',
      height: height,
      offsetY: 20,
    },
    colors: [color, secondaryColor || '#E4E6EF'],
    dataLabels: {
      enabled: true,
    },
    legend: {
      show: false,
      position: 'bottom',
      floating: false,
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
    grid: {
      padding: {
        top: 0,
        bottom: 0,
      },
    },
    plotOptions: {
      radialBar: {
        hollow: {
          margin: 0,
          size: '70%',
        },
        dataLabels: {
          name: {
            show: false,
            fontWeight: '700',
          },
          value: {
            color: color,
            fontSize: '20px',
            fontWeight: '700',
            offsetY: 6,
            show: true,
            formatter (val) {
              return val + ' '
            },
          },
        },
        track: {
          background: secondaryColor,
          strokeWidth: '100%',
        },
      },
    },
  }
}

export default StakeChart
